var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hoverable-item"},[_c('img',{staticClass:"module-icon",attrs:{"alt":"Module icon","src":_vm.moduleImageUrl}}),_c('span',{staticClass:"tooltip-text"},[_vm._v(_vm._s(_vm.$tc(_vm.module.name)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }